import { createEvent, createStore } from 'effector';

export type ConnectionPhase = 'online' | 'updating' | 'reconnecting' | 'unavailable';

export const $setConnectionPhase = createEvent<ConnectionPhase>();
export const $connectionPhase = createStore<ConnectionPhase>('online').on($setConnectionPhase, (_, phase) => phase);

export function isServerUnavailableStatus(status: number | undefined): boolean {
	if (status === undefined) return true;
	return status === 500 || status === 502 || status === 503;
}
